(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jm-herinner-mij"] && !Shopify.designMode) return;
  try {
    (() => {
    const SUBSCRIBED_KEY = 'jm-hm-subscribed';

    const readSubscribed = () => {
      try {
        return JSON.parse(localStorage.getItem(SUBSCRIBED_KEY) || '[]').map(String);
      } catch (e) {
        return [];
      }
    };

    // Eurus zet de gekozen variant in een verborgen input (en vuurt daar 'change' op).
    const watch = (input, callback) => {
      input.addEventListener('change', callback);
      new MutationObserver(callback).observe(input, { attributes: true, attributeFilter: ['value'] });
    };

    const open = (product, variantId, trigger) => {
      document.dispatchEvent(
        new CustomEvent('jm-hm:open', { detail: { product, variantId, trigger, lockVariant: true } })
      );
    };

    const init = (root) => {
      if (root.dataset.jmHmReady !== undefined) return;
      root.dataset.jmHmReady = '';

      // Zonder de sectie 'JM · Herinner mij' (pop-up) blijft de gewone Eurus-knop staan.
      if (!document.querySelector('[data-jm-hm-dialog]')) {
        root.hidden = true;
        return;
      }

      let product;
      try {
        product = JSON.parse(root.querySelector('[data-jm-hm-product]').textContent);
      } catch (e) {
        return;
      }
      const byId = new Map(product.variants.map((v) => [String(v.id), v]));
      const scope = root.closest('.shopify-section') || document;
      const input =
        scope.querySelector('input[name="id"][id^="update-variant-"]:not([id*="sticky"])') ||
        scope.querySelector('form[action*="/cart/add"] input[name="id"]');
      let currentId = String(input ? input.value : product.variants[0].id);

      const sync = () => {
        if (input) currentId = String(input.value);
        const variant = byId.get(currentId);
        if (!variant) return;
        root.hidden = variant.available;
        const done = readSubscribed().includes(currentId);
        root.querySelector('[data-jm-hm-text]').hidden = done;
        root.querySelector('[data-jm-hm-done]').hidden = !done;
      };

      root.querySelector('[data-jm-hm-open]').addEventListener('click', (event) => {
        open(product, currentId, event.currentTarget);
      });
      if (input) watch(input, sync);
      document.addEventListener('jm-hm:subscribed', sync);
      sync();

      // Sticky koopbalk: 'Uitverkocht' daar ook vervangen door 'Herinner mij'.
      const stickyInput = scope.querySelector('input[name="id"][id^="update-variant-sticky-"]');
      const stickyButton = scope.querySelector('button[name="add"][id^="x-atc-button-sticky-"]');
      const template = root.querySelector('template[data-jm-hm-sticky]');
      if (stickyInput && stickyButton && template) {
        const button = template.content.firstElementChild.cloneNode(true);
        const wrapper = stickyButton.parentElement;
        stickyButton.after(button);
        button.addEventListener('click', (event) => {
          event.preventDefault();
          open(product, String(stickyInput.value), button);
        });
        const syncSticky = () => {
          const variant = byId.get(String(stickyInput.value));
          const soldOut = Boolean(variant) && !variant.available;
          wrapper.classList.toggle('jm-hm-sticky', soldOut);
          button.hidden = !soldOut;
        };
        watch(stickyInput, syncSticky);
        syncSticky();
      }
    };

    const initAll = () => document.querySelectorAll('[data-jm-hm-pdp]').forEach(init);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
